import { useState, useEffect, useCallback } from 'react';
import { apiGet, apiPut, getToken } from '../api';

function normalizePortfolioRow(row) {
  var r = row || {};
  return Object.assign({}, r, {
    monthKey: r.monthKey || r.MonthKey || '',
    login: r.login || r.Login || '',
    cu: r.cu || r.CU_Account || '',
    crmOpenDate: r.crmOpenDate || r.CRM_Account_Open_Date || '',
    accountType: r.accountType || r.Account_Type || '',
    isReactivated: r.isReactivated || r.IsReactivated || '',
    reactivationDate: r.reactivationDate || r.ReactivationDate || '',
  });
}

export function usePortfolio() {
  const opts = arguments.length > 0 && arguments[0] ? arguments[0] : {};
  const enabled = opts.enabled !== false;
  const initialDelayMs = typeof opts.initialDelayMs === 'number' ? opts.initialDelayMs : 0;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lastUpdate, setLastUpdate] = useState(null);
  const [error, setError] = useState(null);

  const loadPortfolio = useCallback(async () => {
    if (!enabled) return;
    if (!getToken()) return;
    setLoading(true);
    setError(null);
    try {
      var res = await apiGet('/api/portfolio');
      var rows = res.rows || [];
      setData(rows.map(normalizePortfolioRow));
      setLastUpdate(res.updatedAt || null);
    } catch (err) {
      setError(err.message);
      console.error('Portfolio load error:', err);
      setData([]);
    }
    setLoading(false);
  }, [enabled]);

  const uploadPortfolio = useCallback(async (parsedData) => {
    try {
      var res = await apiPut('/api/portfolio', { rows: parsedData });
      var now = res.updatedAt || null;
      setData((parsedData || []).map(normalizePortfolioRow));
      setLastUpdate(now);
      return true;
    } catch (err) {
      setError(err.message);
      console.error('Portfolio upload error:', err);
      return false;
    }
  }, []);

  useEffect(function() {
    if (!enabled) {
      setLoading(false);
      return;
    }
    if (!getToken()) {
      setLoading(false);
      return;
    }
    if (initialDelayMs > 0) {
      var timer = setTimeout(function() {
        loadPortfolio();
      }, initialDelayMs);
      return function() { clearTimeout(timer); };
    }
    loadPortfolio();
  }, [loadPortfolio, enabled, initialDelayMs]);

  return {
    portfolioData: data,
    portfolioLoading: loading,
    portfolioLastUpdate: lastUpdate,
    portfolioError: error,
    uploadPortfolio,
    reloadPortfolio: loadPortfolio,
  };
}
